import styled from "styled-components";

export const ChartWrapper = styled.div`
  width: 100%;
  // min-width: 295px;
  margin-top: 16px;
`;

export const Card = styled.div`
  background-color: #FBFBFB;
  border-radius: 12px;
  border: 1px solid ${({ theme }) => theme.colors.border} !important;
  padding: 24px;
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;

  @media (max-width: 678px) {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const CardTitle = styled.h2`
  font-size: 22px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.darkGray};
`;

export const ChartContainer = styled.div`
  display: flex;
  flex-direction: column;

  @media (max-width: 678px) {
    flex-direction: row;
  }
`;

export const ChartGridContainer = styled.div`
  display: flex;
  width: 100%;

  @media (max-width: 678px) {
    flex-direction: column;
  }
`;

export const YAxisLabels = styled.div`
  display: flex;
  flex-direction: column-reverse;
  justify-content: space-between;
  align-items: flex-end;
  padding-right: 8px;
  height: 200px;
  position: relative;

  @media (max-width: 678px) {
    flex-direction: row;
    height: auto;
    width: 100%;
    padding-right: 0;
    padding-left: 0px; /* Aligns with ChartArea */
    justify-content: space-between;
    padding-top: 4px;
  }
`;

export const YAxisLabel = styled.span`
  font-size: 12px;
  color: #cbcccd;
`;

export const YAxisKLabel = styled.span`
  font-size: 12px;
  color: #cbcccd;
  position: absolute;
  top: -20px;
  right: 4px;
`;

export const ChartArea = styled.div`
  position: relative;
  width: 100%;
  height: 200px;
`;

export const GridLines = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column-reverse;
  justify-content: space-between;

  @media (max-width: 678px) {
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const GridLine = styled.div`
  width: 100%;
  height: 1px;
  background-color: transparent;
  border-top: 1px dashed #E0E0E0;

  @media (max-width: 678px) {
    width: 1px;
    height: 100%;
    border-top: none;
    border-left: 1px dashed #E0E0E0;
  }
`;

export const ChartBars = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: flex-end;
  height: 100%;
  width: 100%;
  padding: 0 1%;

  @media (max-width: 678px) {
    flex-direction: column;
    align-items: flex-start;
    height: 100%;
    padding: 1% 0;
  }
`;

export const ChartBarContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  justify-content: flex-end;
  flex: 1;
  margin: 0 4px;

  @media (max-width: 767px) {
    margin: 0 2px;
  }

  @media (max-width: 678px) {
    position: relative; /* Ensure tooltip is positioned relative to this */
    flex-direction: row;
    width: 100%;
    height: auto;
    justify-content: flex-start;
    margin: 4px 0;
  }

  @media (max-width: 414px) {
    margin: 0 6px;

    @media (max-width: 678px) {
      margin: 2px 0;
    }
  }
`;

export const ChartBar = styled.div<{ height: number; $active: boolean }>`
  width: 100%;
  max-width: 20px;
  height: ${({ height }) => height}%;
  background-color: ${({ $active, theme }) =>
    $active ? theme.colors.primary : theme.colors.primary};
  border-radius: 4px;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: ${({ theme }) => theme.colors.primary};
  }

  @media (max-width: 678px) {
    width: ${({ height }) => height}%;
    height: 20px;
    max-width: 100%;
    max-height: 20px;
  }

  @media (max-width: 414px) {
    max-width: 100%;
    max-height: 12px;
    height: 12px;
  }
`;

export const HorizontalChartBar = styled.div<{ width: number; $active: boolean }>`
  height: 20px;
  width: ${({ width }) => width}%;
  background-color: ${({ $active, theme }) => ($active ? theme.colors.primary : theme.colors.primary)};
  border-radius: 4px;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: ${({ theme }) => theme.colors.primary};
  }

  @media (max-width: 414px) {
    height: 12px;
  }
`;

export const ChartLabels = styled.div`
  display: flex;
  justify-content: space-around;
  margin-left: 24px;
  padding-top: 8px;
  width: calc(100% - 32px);

  @media (max-width: 678px) {
    flex-direction: column;
    width: auto;
    margin-left: 0;
    padding-top: 0;
    justify-content: space-around;
    height: 200px; /* Match ChartArea height */
  }
`;

export const ChartLabel = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.darkGray};
  text-align: center;
  flex: 1;

  @media (max-width: 678px) {
    text-align: right;
    flex: 1;
    padding-right: 8px;
  }

  @media (max-width: 375px) {
    font-size: 10px;
  }
`;

export const HorizontalChartLabel = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.darkGray};
  text-align: right;
  flex: 1;
  padding-right: 8px;

  @media (max-width: 375px) {
    font-size: 10px;
  }
`;

export const ChartTooltip = styled.div`
  position: absolute;
  bottom: calc(100% + 10px);
  left: 50%;
  transform: translateX(-50%);
  background-color: ${({ theme }) => theme.colors.darkGray};
  color: white;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 12px;
  white-space: nowrap;
  z-index: 10;
  display: flex;
  flex-direction: row;
  align-items: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

  &::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border-width: 6px;
    border-style: solid;
    border-color: ${({ theme }) => theme.colors.darkGray} transparent transparent transparent;
  }

  @media (max-width: 678px) {
    left: 10%;
    top: 50%;
    bottom: auto;
    transform: translate(20px, -50%);

    &::after {
      left: -6px;
      top: 50%;
      transform: translateY(-50%) rotate(-90deg);
    }
  }
`;

export const ChartTooltipTextTop = styled.div`
  font-weight: 600;
  margin-bottom: 4px;
  font-size: ${({ theme }) => theme.fontSizes.large};
  color: #ffffff;
`;

export const ChartTooltipDate = styled.div`
  font-weight: 500;
  margin-bottom: 4px;
  font-size: ${({ theme }) => theme.fontSizes.small};
  color: #d6d6d6;
`;

export const TooltipIcon = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  opacity: 1;
  background-color: #3a3f38;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TooltipGrowth = styled.div`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.secondary};
  font-size: ${({ theme }) => theme.fontSizes.xxlarge};

  img {
    width: 16px;
    height: 16px;
    margin-right: 4px;
  }
`;

export const NoDataMessage = styled.div`
  padding: 20px;
  text-align: center;
  color: ${({ theme }) => theme.colors.darkGray};
  font-size: ${({ theme }) => theme.fontSizes.medium};
`;
